var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","clipRule":"evenodd","d":"M16.8555 4L14.8555 2H10.8555L8.85547 4H5.85547H4.85547V6H5.85547V18C5.85547 19.1046 6.7509 20 7.85547 20H17.8555C18.96 20 19.8555 19.1046 19.8555 18V6H20.8555V4H19.8555H16.8555ZM9.85547 18V6H7.85547V18H9.85547ZM11.8555 6H13.8555V18H11.8555V6ZM17.8555 18V6H15.8555V18H17.8555Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
